import * as visitorCenters from './actions';
import { ActionType, getType } from 'typesafe-actions';
import { VisitorCenterState } from './types';

const defaultState: VisitorCenterState = {
    visitorCenters: [],
    parkCode: '',
    parkName: '',
    latLong: '',
    loading: false,
    loadedVisitorCenters: {},
};

export type VisitorCenterActions = ActionType<typeof visitorCenters>

export default (state = defaultState, action: VisitorCenterActions): VisitorCenterState => {
  switch (action.type) {
    case getType(visitorCenters.fetchVisitorCenters.request):
      return {
        ...state,
        loading: true,
        visitorCenters: [],
      }
    case getType(visitorCenters.fetchVisitorCenters.success):
      return {
        ...state,
        loading: false,
        // visitorCenters: action.payload,
        loadedVisitorCenters: {
          // ...state.loadedVisitorCenters,
          [action.payload[0].parkCode]: action.payload,
        },
      }
    case getType(visitorCenters.fetchSuccessEmpty):
      return {
        ...state,
        loading: false,
        loadedVisitorCenters: {
          // ...state.loadedVisitorCenters,
          [action.payload]: [],
        },
      }
    case getType(visitorCenters.updateParkCode):
      return {
        ...state,
        parkCode: action.payload,
      }
    case getType(visitorCenters.updateParkName):
      return {
        ...state,
        parkName: action.payload,
      }
    case getType(visitorCenters.updateParkLatLong):
      return {
        ...state,
        latLong: action.payload,
      }
    default:
      return state;
  }
};
